const ar = {
  // Navigation
  nav_home: "بيت",
  nav_explore: "يستكشف",
  nav_workspace: "مساحة العمل",
  ws_videos: "أشرطة الفيديو",
  ws_untitled: "فيديو بدون عنوان",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "فشل الفيديو",
  ws_failed_refunded: "تم إرجاع رصيدك",
  ws_failed_dismiss: "رفض",
  ws_failed_retry: "حاول ثانية",
  ws_failed_retrying: "جارٍ البدء…",
  ws_failed_banner_one: "فشل إنشاء الفيديو",
  ws_failed_banner_many: "فشل {n} من مقاطع الفيديو",
  ws_failed_banner_body: "لم يتم تحصيل أي شيء — عاد الرصيد إلى حسابك. حاول مرة أخرى، أو اختر موضوعًا مختلفًا.",
  ws_empty_title: "لا شيء هنا بعد.",
  ws_empty_body: "سيظهر هنا كل مقطع فيديو تنشئه، الأحدث أولاً.",
  ws_generate: "يولد",
  ws_composer_placeholder: "وصف الدرس\u2026",
  ws_placeholder_hw: "قم بتسمية المهمة... (اختياري)",
  ws_placeholder_lecture: "اسم المحاضرة... (اختياري)",
  ws_placeholder_self_study: "ماذا تريد أن تدرس؟",
  nav_search: "بحث في الفيديوهات...",
  nav_search_yours: "ابحث في فيديوهاتك...",
  nav_notifications: "إشعارات",
  nav_mark_all_read: "وضع علامة على كل قراءة",
  nav_no_notifications: "لا توجد إخطارات حتى الآن",
  nav_no_notifications_sub: "سنخبرك عندما تصبح مقاطع الفيديو الخاصة بك جاهزة",
  nav_upgrade: "يرقي",
  nav_billing: "الفواتير",
  nav_settings: "إعدادات",
  nav_contact: "اتصل بنا",
  nav_api: "واجهة برمجة التطبيقات",
  nav_sign_out: "تسجيل الخروج",
  nav_just_now: "الآن",
  nav_minutes_ago: "منذ {n} م",
  nav_hours_ago: "{n} منذ ح",
  nav_days_ago: "{n} منذ",
  nav_used_this_month: "{used} من {cap} المستخدمة هذا الشهر",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} من {limit} المستخدم هذا الأسبوع",
  nav_free_daily: "4 مقاطع فيديو مجانية في الأسبوع",
  // Settings
  settings_title: "إعدادات",
  settings_profile: "حساب تعريفي",
  settings_change_avatar: "تغيير الصورة الرمزية",
  settings_cancel: "يلغي",
  settings_choose_wizard: "اختر المعالج الخاص بك",
  settings_display_name: "اسم العرض",
  settings_your_name: "اسمك",
  settings_save: "يحفظ",
  settings_saving: "توفير...",
  settings_saved: "أنقذ",
  settings_save_failed: "فشل الحفظ",
  settings_email: "بريد إلكتروني",
  settings_notifications: "إشعارات",
  settings_email_notif: "إشعارات البريد الإلكتروني",
  settings_email_notif_desc: "تلقي التحديثات والإعلانات عبر البريد الإلكتروني",
  settings_language: "لغة",
  settings_language_desc: "اختر لغة التطبيق وسرد الفيديو",
  settings_data_title: "البيانات الخاصة بك",
  settings_data_desc: "قم بتنزيل نسخة من البيانات الشخصية المرتبطة بحسابك - بما في ذلك ملفك الشخصي ومقاطع الفيديو والدورات التدريبية والجلسات ورسائل الدعم. لا يتم تضمين سجلات النظام الداخلي وبيانات المعالجة المشتقة.",
  settings_data_download: "تنزيل بياناتي",
  settings_data_exporting: "جارٍ التحضير…",
  settings_danger: "منطقة الخطر",
  settings_delete_account: "حذف الحساب",
  settings_delete_desc: "حذف حسابك وجميع البيانات المرتبطة به نهائيًا. لا يمكن التراجع عن هذا الإجراء.",
  settings_delete_confirm: "سيؤدي هذا إلى حذف حسابك وجميع بياناتك نهائيًا. اكتب {keyword} للتأكيد.",
  settings_delete_placeholder: "اكتب \"حذف\" للتأكيد",
  settings_permanently_delete: "حذف نهائيا",
  settings_deleting: "جارٍ الحذف...",
  explore_watch_now: "شاهد الآن",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "لا معاينة",
  explore_no_videos: "لا توجد مقاطع فيديو متاحة حتى الآن. التحقق مرة أخرى قريبا!",
  explore_featured_courses: "الدورات المميزة",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "العودة إلى الاستكشاف",
  course_not_found: "هذه الدورة غير متوفرة.",
  // Home Page
  home_hero: "تعلم أي شيء،",
  home_hero_accent: "بصريا",
  home_placeholder: "ماذا تريد أن تتعلم أو تحل؟",
  home_extracting: "استخراج الأسئلة...",
  home_videos_generated: "سيتم إنشاء {n, plural, one {فيديو} two {فيديوهان} few {# فيديوهات} many {# فيديو} other {# فيديو}}",
  home_credits: "{n, plural, one {رصيد} two {رصيدان} few {# أرصدة} many {# رصيدًا} other {# رصيد}}",
  home_remaining: "المتبقية هذا الشهر",
  home_enter_prompt: "الرجاء إدخال ما تريد تعلمه أو حله",
  home_popular: "دروس شعبية",
  home_from_community: "من المجتمع",
  home_community_sub: "شاهد ما يقوم الطلاب بإنشائه",
  home_tips_label: "من الساحر المجوسي",
  home_tips_title: "نصائح وحيل",
  home_tip1_title: "كن محددًا",
  home_tip1_desc: "لا تكتب الموضوع كاملا اختر فكرة واحدة، مفهوم واحد، سؤال واحد.",
  home_tip1_example: "كيف يعمل تكرار الحمض النووي في الخلايا حقيقية النواة",
  home_tip2_title: "قل لمن",
  home_tip2_desc: "يبدو شرح المدرسة المتوسطة مختلفًا تمامًا عن محاضرة جامعية.",
  home_tip2_example: "شرح المشتقات لمن تعلم الجبر للتو",
  home_tip3_title: "أخبر ماجي بما تريد",
  home_tip3_desc: "أمثلة، تطبيقات واقعية خطوة بخطوة - فقط قلها وسيتبعك Magi.",
  home_tip3_example: "دورة المياه مع أمثلة من العالم الحقيقي وملخص",
  home_tip_try: "جرب شيئًا مثل",
  home_proven_social: "تابعونا على الانستغرام",
  home_ig_desc_1: "زيادة",
  home_ig_followers: "55.000 متابع",
  home_ig_desc_2: "شاهد مقاطع الفيديو الخاصة بالرياضيات والعلوم على Instagram كل يوم. هذه البكرات مصنوعة بنفس المحرك الذي تستخدمه هنا.",
  home_view_profile: "عرض الملف الشخصي",
  home_subscribe_now: "اشترك الآن",
  home_sub_monthly: "شهريا",
  home_sub_yearly: "سنوي",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "وفر {pct}%",
  home_sub_per_month: "/ شهر",
  home_sub_billed_monthly: "يتم إصدار فاتورة بقيمة ${amount} كل شهر",
  home_sub_processing: "يعالج...",
  home_sub_no_commitment: "لا التزام. إلغاء في أي وقت.",
  home_sub_secured: "مؤمن بواسطة الشريط",
  home_sub_headline: "فتح المزيد مع {plan}",
  home_sub_due_now: "مستحق الآن",
  home_sub_trial_label: "{days}-يوم الوصول الكامل",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "سيتم تحصيل مبلغ ${amount} منك اليوم مقابل {n} من مقاطع الفيديو هذا الشهر. في {date}، يتم تجديده بمبلغ ${amount}/شهر ما لم تقم بالإلغاء أولاً - يمكنك الإلغاء في أي وقت من الفوترة.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "سيتم محاسبتك بمبلغ ${trial} اليوم لمدة {days} يوم من الوصول الكامل، بحد أقصى {n} من مقاطع الفيديو. لا تستمر النسخة التجريبية عند ${trial} — في {date} تصبح تلقائيًا {planName} بسعر ${plan} شهريًا (مقاطع فيديو {full})، ويتم تحصيل رسوم ${plan} كل شهر بعد ذلك حتى تقوم بالإلغاء. إلغاء أي وقت من الفواتير.",
  home_sub_card: "بطاقة الائتمان أو الخصم",
  home_sub_billed_once_yearly: "يتم إصدار فاتورة بقيمة ${amount} مرة واحدة سنويًا",
  home_sub_billed_trial: "يتم إصدار فاتورة بقيمة ${amount} لمدة {days} من الأيام، ثم يتم تجديدها بمبلغ ${renews} كل شهر",
  home_sub_switch_plan: "هل تبحث عن {plan} بدلاً من ذلك؟",
  home_sub_replaces_plan: "يستبدل خطتك {plan}. يظل تاريخ فاتورتك كما هو - يؤدي الانتقال لأعلى إلى فرض الفارق الآن، أما الانتقال لأسفل فيبدأ عند التجديد التالي.",
  home_sub_change_now: "أنت الآن على {plan} — تم تحصيل {amount} مقابل الفرق.",
  home_sub_change_later: "ستنتقل إلى {plan} في {date}. لم يتم تحصيل أي مبلغ اليوم.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} فيديو شهريا",
  // Pricing Page
  pricing_title: "قم بترقية خطتك",
  pricing_monthly: "شهريا",
  pricing_yearly: "سنوي",
  pricing_save: "وفر 17%",
  pricing_best_value: "أفضل قيمة",
  pricing_your_plan: "خطتك الحالية",
  pricing_get_started: "ابدأ",
  pricing_processing: "يعالج...",
  pricing_per_month: "/شهر",
  pricing_billed_yearly: "تمت الفاتورة بقيمة ${amount}/سنة",
  pricing_videos_month: "{n, plural, one {فيديو} two {فيديوهان} few {# فيديوهات} many {# فيديو} other {# فيديو}}/الشهر",
  pricing_manage_cancel: "إدارة أو إلغاء",
  pricing_manage_unavailable: "لم نعثر على اشتراك لإدارته. يرجى التواصل معنا وسنتولى الأمر.",
  pricing_opening: "افتتاح...",
  billing_autorenew_monthly: "يتم تجديد الاشتراك تلقائيًا بسعر ${amount}/الشهر حتى تقوم بالإلغاء.",
  billing_autorenew_yearly: "يتم تجديد الاشتراك تلقائيًا بسعر ${amount}/سنة حتى تقوم بالإلغاء.",
  billing_autorenews_on: "التجديد التلقائي في {date} · الإلغاء في أي وقت",
  pricing_secured: "مؤمن بواسطة الشريط",
  pricing_login_required: "الرجاء تسجيل الدخول للاشتراك",
  pricing_auth_error: "خطأ في مصادقة المستخدم. يرجى محاولة تسجيل الخروج والدخول مرة أخرى.",
  pricing_feature_pdf: "استخراج ملفات PDF والصور",
  pricing_feature_quality: "نموذج عالي الجودة",
  pricing_feature_speed: "أسرع وقت الجيل",
  pricing_feature_study: "جلسات دراسية",
  pricing_free_hint: "حاليا على الخطة المجانية",
  // Billing Page
  billing_title: "الفواتير",
  billing_current_plan: "الخطة الحالية",
  billing_payment_failed_title: "تم إيقاف خطتك مؤقتًا",
  billing_payment_failed_body: "لم نتمكن من جمع {amount}، لذلك تم إيقاف خطتك مؤقتًا. قم بتحديث بطاقتك لبدء تشغيلها مرة أخرى — وسنواصل أيضًا إعادة المحاولة.",
  billing_payment_failed_cta: "إصلاح الدفع",
  billing_change_plan: "تغيير الخطة",
  billing_invoices: "الفواتير",
  billing_loading: "جارٍ تحميل الفواتير...",
  billing_no_invoices: "لا توجد فواتير بعد",
  billing_date: "تاريخ",
  billing_amount: "كمية",
  billing_status: "حالة",
  billing_invoice: "فاتورة",
  billing_view: "منظر",
  // Contact Page
  contact_title: "اتصل بنا",
  contact_placeholder: "كيف يمكننا المساعدة؟",
  contact_sent_desc: "سنعود إليك في أقرب وقت ممكن.",
  contact_signin: "الرجاء تسجيل الدخول للاتصال بالدعم.",
  // Generation Queue
  queue_title: "طابور",
  queue_active: "{n} نشط",
  queue_generating: "{n} توليد",
  queue_ready: "جاهز للمشاهدة",
  queue_in_queue: "في انتظار الدور...",
  queue_almost_ready: "شبه جاهز...",
  queue_seconds_left: "{n} متبقية",
  queue_minutes_left: "{m} م {s} ثانية",
  queue_watch_now: "شاهد الآن",
  queue_waiting: "منتظرين في الطابور...",
  queue_empty: "لا توجد مقاطع فيديو في قائمة الانتظار",
  queue_empty_sub: "أنشئ مقطع فيديو لمشاهدته هنا",
  queue_clear: "مسح الكل",
  queue_total: "{n} المجموع",
  queue_first_time: "يتم إنشاء الفيديو الخاص بك",
  queue_first_time_sub: "عادة ~ 2 دقيقة. ستسمع رنينًا عندما يكون جاهزًا.",
  // Session Expired
  session_expired: "انتهت صلاحية الجلسة",
  session_expired_desc: "لقد انتهت صلاحية جلستك لأسباب أمنية. الرجاء تسجيل الدخول مرة أخرى للمتابعة.",
  // Cookie Banner
  cookie_text: "نحن نستخدم ملفات تعريف الارتباط لتحليل حركة مرور الموقع وتحسين تجربتك. يتم تعيين ملفات تعريف الارتباط الأساسية فقط بشكل افتراضي.",
  cookie_learn_more: "يتعلم أكثر",
  cookie_accept: "قبول الكل",
  cookie_reject: "رفض غير الضرورية",
  // Create Project Modal
  create_new_project: "مشروع جديد",
  create_extracting: "استخراج...",
  create_select_problems: "حدد المشاكل",
  create_select_topics: "حدد المواضيع",
  create_new_video: "فيديو جديد",
  create_new_hw: "مشروع الواجبات المنزلية الجديد",
  create_new_lecture: "مشروع محاضرة جديدة",
  create_new_self_study: "مشروع جديد",
  create_video: "فيديو",
  create_homework: "العمل في المنزل",
  create_lecture: "محاضرة",
  create_self_study: "مشروع",
  create_video_sub: "إنشاء فيديو",
  create_hw_sub: "تحميل الواجبات المنزلية",
  create_lecture_sub: "تحميل الشرائح",
  create_self_study_sub: "اختر مواضيعك",
  create_video_prompt: "ما الذي يجب أن يوضحه الفيديو؟",
  create_project_title: "عنوان المشروع",
  create_video_hint: "سيتم استخدام هذا كعنوان ومطالبة للفيديو الخاص بك.",
  create_drop_hw: "اترك واجباتك المنزلية هنا",
  create_drop_lecture: "أسقط شرائح محاضرتك هنا",
  create_file_types: "بدف، PNG، جبغ، هيك",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "إسقاط لبدء المشروع",
  create_reading_hw: "قراءة واجباتك المنزلية",
  create_reading_lecture: "قراءة محاضرتك",
  create_finding_problems: "اكتشاف و حل المشاكل...",
  create_finding_topics: "استخراج المواضيع...",
  create_add_video: "أضف فيديو آخر",
  create_add_more_files: "إضافة المزيد من الملفات",
  create_starting: "بداية الجيل...",
  create_generate_video: "قم بإنشاء رصيد فيديو \u00B7 1",
  create_generate_n: "إنشاء {n, plural, one {فيديو} two {فيديوهان} few {# فيديوهات} many {# فيديو} other {# فيديو}} \u00B7 {n, plural, one {رصيد} two {رصيدان} few {# أرصدة} many {# رصيدًا} other {# رصيد}}",
  create_create_project: "إنشاء مشروع \u00B7 {n, plural, one {رصيد} two {رصيدان} few {# أرصدة} many {# رصيدًا} other {# رصيد}}",
  create_no_problems: "لا يمكن العثور على أي مشاكل. جرّب صورة أكثر وضوحًا أو صفحة مختلفة.",
  create_no_topics: "لم يتم العثور على أي مواضيع. جرّب صورة أكثر وضوحًا أو ملفًا مختلفًا.",
  create_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  create_extract_daily_limit: "هذه هي كل الوثائق لهذا اليوم. المزيد غدا.",
  create_video_topic_placeholder: "موضوع الفيديو {n}، على سبيل المثال. \"القيم الذاتية والمتجهات الذاتية\"",
  video_share: "يشارك",
  // and made the two indistinguishable.
  video_followup_placeholder: "إنشاء فيديو للمتابعة...",
  video_chip_simpler: "اشرح بشكل أسهل",
  video_chip_harder: "مثال أصعب",
  video_chip_real_world: "استخدام في العالم الحقيقي",
  // spends a credit generating a new one.
  video_ask_title: "اسأل عن هذا الفيديو",
  video_ask_cta: "الدردشة حول هذا",
  video_ask_placeholder: "اطرح سؤالا...",
  video_ask_thinking: "أفكر...",
  video_ask_close: "يغلق",
  video_ask_chip_explain: "اشرح ذلك الجزء",
  video_ask_chip_example: "أعط مثالا",
  video_ask_chip_why: "لماذا يعمل هذا؟",
  video_ask_limit_reached: "لقد وصلت إلى الحد الأقصى للأسئلة اليوم. سيتم إعادة تعيينه غدًا.",
  video_up_next: "التالي",
  video_no_suggested: "لا توجد مقاطع فيديو مقترحة حتى الآن",
  video_untitled: "فيديو بدون عنوان",
  video_created_recently: "تم إنشاؤها مؤخرًا",
  video_just_now: "الآن",
  video_minutes_ago: "منذ {n, plural, one {دقيقة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}}",
  video_hours_ago: "منذ {n, plural, one {ساعة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}}",
  video_days_ago: "منذ {n, plural, one {يوم} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  video_weeks_ago: "منذ {n, plural, one {أسبوع} two {أسبوعين} few {# أسابيع} many {# أسبوعًا} other {# أسبوع}}",
  video_months_ago: "منذ {n, plural, one {شهر} two {شهرين} few {# أشهر} many {# شهرًا} other {# شهر}}",
  video_years_ago: "منذ {n, plural, one {سنة} two {سنتين} few {# سنوات} many {# سنة} other {# سنة}}",
  video_unknown_date: "تاريخ غير معروف",
  video_download_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  // Search Results
  search_no_results: "لم يتم العثور على نتائج",
  search_no_results_for: "لم يتم العثور على نتائج لـ \"{query}\"",
  search_all_videos: "البحث في جميع مقاطع الفيديو",
  search_enter_term: "أدخل مصطلح البحث للعثور على مقاطع الفيديو",
  search_retry: "أعد محاولة البحث",
  auth_continue_google: "تواصل مع جوجل",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "ابدأ وصولي على الفور. أدرك أن هذا يعني أنني أتخلى عن حقي البالغ {days}-day في الانسحاب واسترداد الأموال.",
  home_sub_waiver_required: "يرجى تأكيد هذا للمتابعة.",
  home_sub_agree_prefix: "من خلال الاستمرار، فإنك توافق على لدينا",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "يجب أن يكون عمرك {age} أو أكبر حتى تتمكن من استخدام Magi.",
  auth_agree_prefix: "من خلال تسجيل الدخول، فإنك توافق على لدينا",
  auth_terms: "شروط الخدمة",
  auth_and: "و",
  auth_privacy: "سياسة الخصوصية",
  auth_email_optin: "أرسل لي النصائح والتحديثات",
  // Auth modal (Google + email/password)
  auth_signin_title: "تسجيل الدخول إلى المجوس",
  auth_signin_desc: "التقط من حيث توقفت.",
  auth_signup_title: "أنشئ حسابك",
  auth_signup_desc: "مجاني للبدء، لا حاجة لبطاقة.",
  auth_or: "أو",
  auth_continue_email: "تواصل مع البريد الإلكتروني",
  auth_signing_in: "تسجيل الدخول...",
  auth_working: "مجرد ثانية…",
  auth_email_placeholder: "عنوان البريد الإلكتروني",
  auth_password_placeholder: "كلمة المرور",
  auth_signin_submit: "تسجيل الدخول",
  auth_signup_submit: "إنشاء حساب",
  auth_no_account: "جديد هنا؟",
  auth_signup_link: "إنشاء حساب",
  auth_have_account: "هل لديك حساب بالفعل؟",
  auth_signin_link: "تسجيل الدخول",
  auth_forgot_password: "نسيت كلمة السر؟",
  auth_reset_title: "إعادة تعيين كلمة المرور الخاصة بك",
  auth_reset_desc: "سنرسل إليك رابطًا عبر البريد الإلكتروني لتعيين رابط جديد.",
  auth_reset_submit: "إرسال رابط إعادة التعيين",
  auth_reset_sent: "تحقق من بريدك الإلكتروني للحصول على رابط إعادة التعيين.",
  auth_back_to_signin: "العودة لتسجيل الدخول",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "قم بتأكيد بريدك الإلكتروني للمتابعة",
  verify_wall_desc: "لقد أرسلنا رابط تأكيد إلى {email}. انقر فوقه، ثم عد إلى هنا.",
  verify_wall_check: "لقد أكدت ذلك",
  verify_wall_checking: "جارٍ التحقق...",
  verify_wall_still_unverified: "لم يتم تأكيده بعد. انقر فوق الرابط الموجود في البريد الإلكتروني، ثم حاول مرة أخرى.",
  verify_wall_resend: "أرسل الرابط مرة أخرى",
  verify_wall_resent: "مرسل. تحقق من صندوق الوارد الخاص بك ومجلد البريد العشوائي الخاص بك.",
  verify_wall_wrong_account: "حساب خاطئ؟ تسجيل الخروج",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "تأكيد بريدك الإلكتروني",
  verify_action_working_desc: "لحظة واحدة.",
  verify_action_done_title: "أنت جاهز تمامًا",
  verify_action_done_desc: "تم تأكيد بريدك الإلكتروني. مرحبا بكم في Magi.",
  verify_action_done_cta: "ابدأ التعلم",
  verify_action_failed_title: "هذا الرابط لا يعمل",
  verify_action_failed_desc: "ربما تم استخدامه بالفعل، أو انتهت صلاحيته. عد وأرسل لنفسك واحدة جديدة.",
  verify_action_failed_cta: "العودة إلى Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "تسجيل الدخول للمشاهدة",
  auth_watch_desc: "قم بإنشاء حساب مجاني لتشغيل هذا الفيديو.",
  auth_watch_ready_title: "الفيديو الخاص بك جاهز",
  auth_watch_ready_desc: "قم بتسجيل الدخول لمشاهدته — سيتم حفظه في حسابك.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "قم بتسجيل الدخول للتنزيل",
  auth_download_desc: "قم بإنشاء حساب مجاني لحفظ هذا الفيديو.",
  auth_ask_title: "قم بتسجيل الدخول لتسأل",
  auth_ask_desc: "أنشئ حسابًا مجانيًا للاستفسار عن هذا الفيديو.",
  auth_browse_title: "تسجيل الدخول للتصفح",
  auth_browse_desc: "قم بإنشاء حساب مجاني لاستكشاف كل درس.",
  auth_workspace_title: "قم بتسجيل الدخول لرؤية عملك",
  auth_workspace_desc: "دروسك ومشاريعك موجودة في حسابك.",
  auth_generate_title: "قم بتسجيل الدخول لمواصلة الإنشاء",
  auth_generate_desc: "الحسابات المجانية تحصل على فيديو كل يوم.",
  video_restricted: "هذا الفيديو غير متوفر بعد.",
  // Share sheet
  share_title: "شارك هذا الفيديو",
  share_desc_mobile: "انشرها في قصتك، أو أرسلها إلى صديق، أو انسخ الرابط.",
  share_desc_desktop: "انسخ الرابط أو قم بتنزيل الفيديو لنشره من هاتفك.",
  share_to_apps: "شارك على Instagram والمزيد",
  share_copy_link: "نسخ الوصلة",
  share_copied: "تم نسخ الرابط",
  share_download: "قم بتنزيل الفيديو",
  share_preparing: "تجهيزها…",
  share_watermark_note: "تتضمن مقاطع الفيديو المشتركة موقع magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "مرحبا بكم في المجوس",
  welcome_subtitle: "لديك 4 مقاطع فيديو مجانية للبدء.",
  welcome_optin_reward: "+1 فيديو مجاني",
  welcome_continue: "يكمل",
  age_gate_continue: "يكمل",
  age_gate_saving: "توفير...",
  // Landing Page
  landing_hero: "اكتب موضوعا.",
  landing_hero2: "احصل على درس فيديو.",
  landing_subtitle: "يقوم Magi بتحويل أي موضوع إلى فيديو متحرك جميل يتم سرده في دقائق. لا تصوير، لا تحرير، لا حاجة للخبرة.",
  landing_signup_google: "قم بالتسجيل مع جوجل",
  landing_signing_in: "تسجيل الدخول...",
  landing_chat_bubble: "كيف يستخدم نظام تحديد المواقع العالمي (GPS) النسبية؟",
  landing_stats_title: "موثوق بها من قبل المتعلمين في جميع أنحاء العالم",
  landing_stat_videos: "3000+",
  landing_stat_videos_desc: "تم إنشاء مقاطع الفيديو",
  landing_stat_languages_desc: "اللغات",
  landing_stat_speed: "~1 دقيقة",
  landing_stat_speed_desc: "زمن الجيل",
  landing_feature_lecture_title: "قم بإسقاط ملاحظات المحاضرات الخاصة بك، واحصل على مقاطع الفيديو",
  landing_feature_lecture_desc: "قم بتحميل الشرائح أو الملاحظات الخاصة بك. يقوم Magi بسحب كل موضوع وإنشاء شرح فيديو لكل موضوع.",
  landing_feature_hw_title: "عالقة في الواجبات المنزلية؟ قم بتحميله.",
  landing_feature_hw_desc: "قم بإسقاط مجموعة مشكلات وسيقوم Magi باستخراج كل مشكلة، ثم يرشدك خلال الحل في مقطع فيديو خطوة بخطوة.",
  landing_feature_chat_title: "اطرح الأسئلة أثناء المشاهدة",
  landing_feature_chat_desc: "يأتي كل فيديو مزودًا بمدرس يعمل بالذكاء الاصطناعي يمكنك الدردشة معه. اطرح أسئلة متابعة، أو احصل على تفسيرات أعمق، أو اطلب مقطع فيديو جديدًا عن جزء محدد تريد فهمه بشكل أفضل.",
  landing_feature_lang_title: "تعلم بلغتك",
  landing_feature_lang_desc: "يُنشئ Magi مقاطع فيديو باللغات الإنجليزية والإسبانية والهندية والصينية واليابانية والمزيد. اكتب موضوعك بأي لغة واحصل على درس مروى بالكامل بتلك اللغة.",
  landing_cta_title: "ابدأ التعلم في ثوانٍ",
  landing_cta_google: "تواصل مع جوجل",
  // Onboarding Bubbles
  onboarding_step1: "هذا ليس برنامج دردشة آلي \u2014 اكتب موضوعًا وسأقوم بإنشاء درس فيديو كامل لك!",
  onboarding_step2: "أو قم بإسقاط ملف PDF أو صورة وسأقوم بتحويل كل مشكلة إلى حل فيديو خطوة بخطوة",
  onboarding_step3: "اضغط على \"انطلق\" وسينضم الفيديو الخاص بك إلى قائمة الانتظار. يمكنك الاستمرار في التصفح أثناء العرض!",
  onboarding_generating: "هذا هو درسك الذي يستغرق بضع دقائق. استمر في التصفح إذا أردت؛ سوف تهبط هنا عندما تكون جاهزة",
  onboarding_skip: "يتخطى",
  onboarding_next: "التالي",
  onboarding_done: "فهمتها!",
  // Generating Cards Row
  generating_label: "توليد",
  // Lecture Session (Self Study)
  lecture_loading: "تحميل...",
  lecture_fallback_title: "محاضرة",
  lecture_building: "بناء الفيديو...",
  lecture_building_time: "يستغرق هذا عادة 2-4 دقائق",
  lecture_failed: "فشل إنشاء الفيديو",
  lecture_no_video: "لا يوجد فيديو بعد",
  lecture_followup: "المتابعة",
  lecture_now_playing: "العب الآن",
  lecture_tab_videos: "فيديوهات",
  lecture_tab_chat: "محادثة",
  lecture_chat_empty: "اسأل أي شيء حول هذا الموضوع",
  lecture_chat_chip1: "اشرح ببساطة",
  lecture_chat_chip2: "أعط مثالا",
  lecture_chat_chip3: "لماذا هذا مفيد؟",
  lecture_chat_placeholder: "اسأل عن هذا الموضوع...",
  lecture_followup_placeholder: "إضافة فيديو متابعة...",
  lecture_chat_error: "عذرًا، لم أتمكن من معالجة ذلك. حاول ثانية.",
  lecture_chat_generic_error: "حدث خطأ ما. حاول ثانية.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "الواجبات المنزلية PDF",
  home_sc_hw_desc: "قم بتحميل مجموعة المشكلات، واحصل على فيديو عملي لكل سؤال",
  home_sc_lecture_title: "محاضرة PDF",
  home_sc_lecture_desc: "تحويل الشرائح أو الملاحظات إلى سلسلة من الدروس",
  home_sc_course_title: "إنشاء دورة",
  home_sc_course_desc: "خطط لسلسلة من الدروس حول موضوع واحد",
  // Misc
  generic_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  loading: "تحميل...",
};

export default ar;
